/** Initialen-Kreis einer Person. Die Klassen .user-info / .user-avatar stehen global in styles.scss. */
export interface AvatarBadge {
  initials: string;
  color: string;
}

export function initialsAndColor(name: string): AvatarBadge {
  if (!name) {
    return { initials: '', color: '#ccc' };
  }

  const initials = name
    .split(' ')
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();

  return { initials, color: colorFromName(name) };
}

/** Gleicher Name, gleiche Farbe — ohne Zufall, damit eine Person überall gleich aussieht. */
function colorFromName(name: string): string {
  const hash =
    Array.from(name).reduce((acc, char) => acc + char.charCodeAt(0), 0) % 360;

  return `hsl(${hash}, 85%, 55%)`;
}
